<template>
	<div id="app" class="app" ref="app">
		<main class="site-main">
			<transition name="router-anime">
				<router-view/>
			</transition>
		</main>
	</div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.page {
	position: absolute;
	width: inherit;

	@include mq($lg) {
		width: 100%;
		position: relative;
	}
}

.router-anime-enter-active {
	animation: coming 0.1s;
	animation-delay: .1s;
	opacity: 0;
}

.router-anime-leave-active {
	animation: going 0.7s;
}

@keyframes going {
	from {
		transform: translateX(0);
	}
	to {
		opacity: 0;
	}
}

@keyframes coming {
	from {
		opacity: 0;
	}
	to {
		transform: translateX(0);
		opacity: 1;
	}
}
</style>
